<template>
    <div>
      <transition name="moveing">
        <navgateOther v-show="isShowTopTitle"></navgateOther>
      </transition>
      
      <main class="index_main_content" ref="parentDiv">
        <div class="index_main_body other">
          <div class="zcgy_img"><img src="../../../assets/img/news/news-banner.jpg"><div class="mask_bg"></div></div>
          <div class="zcgy_word">
            <div class="zcgy_ch">新闻动态</div>
            <div class="zcgy_en">News Information</div>
          </div>
        </div>
        <!--新闻列表-->
        <div class="web_content_layout">
          <div class="web_title">媒体新闻</div>
          <ImageTitleListView  :messageList="newsList.list" :perPage="perPage" detailRouter="newsDetail"></ImageTitleListView>
        </div>
      </main>
      <footer-build @gotoBody="gotoBody"></footer-build>
    </div>
  </template>
  <script>
  import ImageTitleListView from '../titleNews/ImageTitleListView.vue'
  import UtilEvent from '../utils/UtilEvent.js'
  export default {
    name: 'newsList',
    components:{UtilEvent,ImageTitleListView},
    props: {
      
    },
    created(){
        
    },
    data () {
      return {
        newsList:{total:0,perPage:1,list:[]},
        perPage:1,
        oldScrollTop:0,
        isShowTopTitle:true
      }
    },
    computed:{
      
    },
    methods:{
      gotoBody(){
        this.$refs.parentDiv.scrollIntoView({
            behavior: "smooth",  // 平滑过渡
        });
      },
      
      scrolling(){
        //获取dom滚动距离
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop ||
                    document.body.scrollTop;
        let scrollStep = scrollTop - this.oldScrollTop;
        this.oldScrollTop = scrollTop;
        if (scrollStep < 0) {
              this.isShowTopTitle = true;
          } else {

             if(scrollStep > 10){
                this.isShowTopTitle = false;
              }
          }
      },
      
    },
    watch:{
      
    },
    mounted(){
      setTimeout(()=>{
        window.addEventListener("scroll", this.scrolling)
      },300)
        new UtilEvent().getNewsListData(this);
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="less"> 

  </style>
  